import { useQuery, useReactiveVar } from '@apollo/client';
import { GET_PLAYLISTS_FOR_TREATBOX } from '../../graphql/queries/playlist/playlist';
import {
  dismissLoadingMessage,
  displayErrorMessage,
} from '../../utils/helpers';
import { organisationLoggedInAs } from '../../utils/reactiveVars';

const useGetPlaylistsForTreatbox = (createdBy, variables) => {
  const organisationRef = useReactiveVar(organisationLoggedInAs)?.id || null;

  const includeOrganisationRefForTypes = ['shared', 'user'];

  const { data, loading, error, refetch, fetchMore } = useQuery(
    GET_PLAYLISTS_FOR_TREATBOX,
    {
      variables: {
        createdBy,
        ...(includeOrganisationRefForTypes.includes(createdBy) && {
          organisation_ref: organisationRef,
        }),
        ...variables,
      },
      onCompleted: () => dismissLoadingMessage(),
      onError: () => {
        dismissLoadingMessage();
        displayErrorMessage('Could not load playlists for TreatBox');
      },
    }
  );

  return { data, loading, error, refetch, fetchMore };
};

export default useGetPlaylistsForTreatbox;
